import classNames from 'classnames'

import { DocumentProcessingStatusType, DocumentRecord } from '../../../models/Document'
import { useDocumentProcessingStatus } from '../DocumentUpload/hooks'

import { DOCUMENT_PROCESSING_STATUS_ICON_CLASS_NAME_MAPPING, DOCUMENT_PROCESSING_STATUS_ICON_MAPPING, DOCUMENT_PROCESSING_STATUS_TEXT_MAPPING } from './models'

import './DocumentProcessingStatus.scss'

const _CONTAINER_CLASS_NAME_MAPPING: Partial<Record<DocumentProcessingStatusType, string>> = {
  [DocumentProcessingStatusType.SAVED]: 'border zocks-border-0.5 zocks-border-color-gray-400',
  [DocumentProcessingStatusType.READY]: 'border zocks-border-0.5 zocks-border-color-gray-400',
}

const _STATUS_TEXT_CLASS_NAME_MAPPING = {
  [DocumentProcessingStatusType.SAVED]: 'bold',
  [DocumentProcessingStatusType.READY]: 'bold',
  [DocumentProcessingStatusType.LOADING]: 'zocks-text-gray-600',
  [DocumentProcessingStatusType.PROCESSING]: 'zocks-text-gray-600',
}

interface DocumentProcessingStatusProps {
  document: DocumentRecord
}

export const DocumentProcessingStatus: React.FC<DocumentProcessingStatusProps> = ({ document }) => {
  const { processingStatusType } = useDocumentProcessingStatus(document)

  const containerClassName = _CONTAINER_CLASS_NAME_MAPPING[processingStatusType]
  const iconClassName = DOCUMENT_PROCESSING_STATUS_ICON_CLASS_NAME_MAPPING[processingStatusType]
  const statusTextClassName = _STATUS_TEXT_CLASS_NAME_MAPPING[processingStatusType]

  return (
    <div className={classNames('px-2 py-1 d-flex align-items-center gap-2 document-processing-status-container', containerClassName)}>
      <div className={classNames('document-processing-icon-container d-flex align-items-center justify-content-center', iconClassName)}>
        {DOCUMENT_PROCESSING_STATUS_ICON_MAPPING[processingStatusType]}
      </div>
      <span className={classNames('paragraph-small text-nowrap', statusTextClassName)}>{DOCUMENT_PROCESSING_STATUS_TEXT_MAPPING[processingStatusType]}</span>
    </div>
  )
}
